import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import BenefitFeatures from '../benefit-features/benefit-features';
import { SectionContainer } from './styles';
import type { FeaturesForm } from './types';

interface BenefitFeaturesElementProps {
  form: FeaturesForm;
  benefitId: string | undefined;
}

const BenefitFeaturesElement = ({
  form,
  benefitId,
}: BenefitFeaturesElementProps) => {
  if (!benefitId) return null;
  return (
    <SectionContainer>
      <FormProvider {...form}>
        <BenefitFeatures benefitId={benefitId} />
      </FormProvider>
    </SectionContainer>
  );
};

export default memo(BenefitFeaturesElement);
